export default "__VITE_ASSET__j813M9fK__"